/**
 * Reviews tract entry - mount Vue-острова отзывов сингла (29.07).
 *
 * Канон checkout.js: конфиг data-атрибутами с mount-ноды, страница
 * линкует ['vendor', 'reviews'] (грабля 11: chunk'и volt линкует явно).
 *
 * Ленивая загрузка: fetch НЕ на mount, а при первом открытии таба
 * Reviews (или сразу, если таб уже активен) - сингл не тратит запрос,
 * пока отзывы не нужны.
 */
import { createApp } from 'vue';
import http from './plugins/http';
import ReviewsApp from '../components/Product/ReviewsApp.vue';

const mount = document.getElementById('reviews-app');

if( mount ) {

    const app = createApp( ReviewsApp, {
        productId : parseInt( mount.dataset.product, 10 ) || 0,
        pageSize  : parseInt( mount.dataset.pageSize, 10 ) || 10,
    } );

    app.use( http );

    const vm = app.mount( mount );

    // первый fetch - при открытии таба Reviews
    const tabBtn = document.querySelector('.tab-btn[data-tab="reviews"]');

    if( tabBtn )
        tabBtn.addEventListener( 'click', () => vm.load() );

    // таб уже активен (прямой заход с #reviews) - грузим сразу
    if( document.getElementById('tab-reviews')?.classList.contains('active') || window.location.hash === '#reviews' )
        vm.load();
}